import React from 'react';
import { notifyBrokerageDataChanged } from 'Components/Banking/brokerageDataBus';
import './Brokerage.css';

// Stop-Loss-Dialog fuer eine Depot-Position (Chat vom 2026-08-11). Setzt/aendert/
// entfernt eine native IB-STP-Order (Stop-Market, GTC): wird der Stopkurs
// erreicht, verkauft IB die Position unlimitiert. Die Order ist ein impliziter
// Auftrag - im Orderbuch ausgeblendet, nur hier verwaltbar (siehe Plan
// "sleepy-whistling-waterfall", IbBrokerageSetStop.inc/IbBrokerageRemoveStop.inc).
//
// props: x, target ({conId, symbol, secType, exchange, currency, action
// (Gegenrichtung der Position: Long->SELL, Short->BUY), quantity (volle
// Positionsgroesse), currentPrice?, stopPrice? (bestehender Stop), orderId?
// (bestehende Stop-Order -> Aendern statt Neu), label?}), onCancel(), onDone().

// Stopkurs kompakt (max. 3 Nachkommastellen, wie die uebrige Kursanzeige).
function formatPrice(value) {
	if (value == null || value === '') return '–';
	const parsed = parseFloat(value);
	return Number.isNaN(parsed) ? '–' : parsed.toLocaleString('de-DE', { maximumFractionDigits: 3 });
}

export default function IbBrokerageStopForm(props) {
	const x = props.x;
	const target = props.target;
	const isChange = target.orderId != null;
	const isSell = target.action === 'SELL'; // Long-Position -> Stop verkauft

	const [stopPrice, setStopPrice] = React.useState(
		target.stopPrice != null && target.stopPrice !== '' ? Math.round(parseFloat(target.stopPrice) * 1000) / 1000 : ''
	);
	const [confirming, setConfirming] = React.useState(false);
	const [removing, setRemoving] = React.useState(false);
	const [sending, setSending] = React.useState(false);
	const [error, setError] = React.useState('');
	const [result, setResult] = React.useState(null);

	// Plausibilitaets-Hinweis (nicht blockierend, Verantwortung beim Anwender):
	// Ein Stop auf der falschen Seite des aktuellen Kurses loest sofort aus.
	// Long (SELL-Stop) gehoert UNTER den Kurs, Short (BUY-Stop) DARUEBER.
	const price = target.currentPrice != null ? parseFloat(target.currentPrice) : null;
	const stopNum = stopPrice !== '' ? parseFloat(stopPrice) : null;
	let wrongSide = false;
	if (price != null && stopNum != null && !Number.isNaN(stopNum)) {
		wrongSide = isSell ? stopNum >= price : stopNum <= price;
	}

	function submit() {
		if (stopNum == null || Number.isNaN(stopNum) || stopNum <= 0) {
			setError('Bitte einen gültigen Stopkurs eingeben.');
			return;
		}
		if (!confirming) {
			setConfirming(true);
			return;
		}
		setSending(true);
		setError('');
		const body = {
			conId: target.conId,
			symbol: target.symbol,
			secType: target.secType,
			exchange: target.exchange,
			currency: target.currency,
			action: target.action,
			totalQuantity: target.quantity,
			stopPrice: stopNum,
		};
		if (isChange) {
			body.orderId = target.orderId;
		}
		x.was.axPost('Backend/webapp.php?module=IbBrokerage&task=IbBrokerageSetStop', body, (res) => {
			setSending(false);
			const content = res.data.content || {};
			if (res.data.returncode !== 1 || content.error) {
				setError(content.error || 'Stop konnte nicht gesetzt werden - IB-Trading ist vermutlich nicht freigeschaltet.');
				return;
			}
			setResult({ mode: isChange ? 'changed' : 'set', stopPrice: stopNum });
			notifyBrokerageDataChanged(x);
		});
	}

	function remove() {
		if (!removing) {
			setRemoving(true);
			return;
		}
		setSending(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=IbBrokerage&task=IbBrokerageRemoveStop', { orderId: target.orderId }, (res) => {
			setSending(false);
			const content = res.data.content || {};
			if (res.data.returncode !== 1 || content.error) {
				setError(content.error || 'Stop konnte nicht entfernt werden.');
				return;
			}
			setResult({ mode: 'removed' });
			notifyBrokerageDataChanged(x);
		});
	}

	// Return loest den aktiven Primaerbutton aus (analog IbBrokerageOrderForm) -
	// erst "Weiter", dann verbindlich. Nicht, wenn gerade der Entfernen-Zweig
	// bestaetigt wird oder ein Button fokussiert ist.
	function handleKeyDown(e) {
		if (e.key !== 'Enter' || e.target.tagName === 'BUTTON' || sending || removing) {
			return;
		}
		e.preventDefault();
		submit();
	}

	if (result) {
		const text = result.mode === 'removed'
			? 'Stop-Loss entfernt.'
			: (result.mode === 'changed' ? 'Stop-Loss geändert' : 'Stop-Loss gesetzt') + ' bei ' + formatPrice(result.stopPrice) + '.';
		return (
			<div className="brokerage-card">
				{props.onDone && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onDone}></i>}
				<h4>Stop-Loss: {target.label || target.symbol}</h4>
				<p>{text}</p>
				<button type="button" className="btn btn-primary" onClick={() => props.onDone && props.onDone()}>Schließen</button>
			</div>
		);
	}

	return (
		<div className="brokerage-card" onKeyDown={handleKeyDown}>
			{props.onCancel && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onCancel}></i>}
			<h4>Stop-Loss: {target.label || target.symbol}</h4>
			{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
			<div className="ib-stop-info">
				<span>{isSell ? 'Long-Position' : 'Short-Position'} · {target.quantity} Stück</span>
				{price != null && <span>Kurs aktuell: <strong>{formatPrice(price)}</strong></span>}
			</div>
			<div className="brokerage-field-row">
				<label>Stopkurs</label>
				<input
					type="number"
					step="any"
					autoFocus
					value={stopPrice}
					onChange={(e) => { setStopPrice(e.target.value); setConfirming(false); setRemoving(false); }}
				/>
			</div>
			<p className="brokerage-hint">
				<i className="bi bi-info-circle"></i> Wird der Stopkurs erreicht, wird die Position <strong>unlimitiert</strong> (zum Marktpreis) verkauft. Die Order liegt bei IB und wirkt auch, wenn diese App offline ist.
			</p>
			{wrongSide &&
				<p className="brokerage-error">
					<i className="bi bi-exclamation-triangle"></i> Achtung: Der Stopkurs liegt auf der {isSell ? 'falschen (über dem Kurs)' : 'falschen (unter dem Kurs)'} Seite und würde <strong>sofort auslösen</strong>.
				</p>
			}
			{confirming &&
				<p className="brokerage-hint">
					<i className="bi bi-exclamation-triangle"></i> Bei Bestätigung wird dieser Stop-Loss SOFORT bei IB {isChange ? 'geändert' : 'platziert'}.
				</p>
			}
			{removing &&
				<p className="brokerage-hint">
					<i className="bi bi-exclamation-triangle"></i> Bei Bestätigung wird der Stop-Loss SOFORT bei IB entfernt.
				</p>
			}
			<div className="brokerage-order-detail-actions">
				<button type="button" className="btn btn-secondary" onClick={() => props.onCancel && props.onCancel()}>Abbrechen</button>
				{isChange &&
					<button type="button" className="btn btn-danger" disabled={sending} onClick={remove}>
						{removing ? 'Wirklich entfernen' : 'Entfernen'}
					</button>
				}
				<button type="button" className="btn btn-primary" disabled={sending || removing} onClick={submit}>
					{sending ? 'Sende…' : (confirming ? 'Jetzt verbindlich senden' : (isChange ? 'Ändern' : 'Setzen'))}
				</button>
			</div>
		</div>
	);
}
